import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const caseLike = (found, rep) => {
  if (/\p{L}{2}/u.test(found) && found === found.toUpperCase()) return rep.toUpperCase();
  const f = found.charAt(0);
  return (f === f.toLowerCase() ? rep.charAt(0).toLowerCase() : rep.charAt(0).toUpperCase()) + rep.slice(1);
};
export const replaceTerm = (text, from, to) => text.replace(new RegExp(esc(from), "giu"), (m) => caseLike(m, to));

// Other rows whose translation still contains the old wording
export const findSimilar = (dict, key, from) => {
  if (!from || from.trim().length < 3) return [];
  const re = new RegExp(esc(from.trim()), "iu");
  return Object.entries(dict).filter(([k, v]) => k !== key && v && re.test(v)).map(([k, v]) => ({ key: k, text: v }));
};

export const GuidedReviewDialog = ({ proposal, onClose, onApply }) => {
  const [checked, setChecked] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { setChecked(Object.fromEntries((proposal?.rows || []).map((r) => [r.key, true]))); }, [proposal]);
  if (!proposal) return null;
  const { from, to, rows } = proposal;
  const chosen = rows.filter((r) => checked[r.key]);
  const apply = async () => { setBusy(true); await onApply(chosen.map((r) => ({ key: r.key, text: replaceTerm(r.text, from, to) }))); setBusy(false); };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="guided-review-dialog">
        <DialogHeader>
          <DialogTitle>Corriger les autres lignes ?</DialogTitle>
          <DialogDescription>
            {rows.length} autre(s) ligne(s) contiennent encore « {from} ». Remplacer par « {to} » ?
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {rows.map((r) => (
            <label key={r.key} className="flex gap-3 items-start rounded-md border border-border p-2 text-xs cursor-pointer" data-testid="guided-review-row">
              <input type="checkbox" className="mt-0.5" checked={!!checked[r.key]} onChange={(e) => setChecked({ ...checked, [r.key]: e.target.checked })} data-testid="guided-review-check" />
              <div className="space-y-1 min-w-0">
                <div className="text-muted-foreground">{r.key}</div>
                <div className="line-through text-muted-foreground/80">{r.text}</div>
                <div className="font-medium">{replaceTerm(r.text, from, to)}</div>
              </div>
            </label>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="guided-review-skip">Ne rien changer</Button>
          <Button onClick={apply} disabled={busy || !chosen.length} data-testid="guided-review-apply">
            {busy ? "Remplacement…" : `Remplacer dans ${chosen.length} ligne(s)`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
